import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cancelButton: 'Cancel',
    confirmButton: 'Delete the virtual card',
    subtitleInfo:
      'This card will be permanently deleted and cannot be reactivated.',
    subtitleNoMoreCardsInQuota:
      'You will no longer have virtual cards included until your subscription is renewed.',
    title: 'Are you sure you want to delete this card?',
    toastDeactivationSuccess: 'This virtual card was deleted.',
    toastQueryError: 'Oops! There was an unknown error.',
  },
  fr: {
    cancelButton: 'Annuler',
    confirmButton: 'Supprimer la carte',
    subtitleInfo:
      'Cette carte sera définitivement supprimée et ne pourra plus être réactivée.',
    subtitleNoMoreCardsInQuota:
      "Vous n'aurez plus de cartes virtuelles incluses jusqu'au renouvellement de votre abonnement.",
    title:
      'Êtes-vous sûr de vouloir définitivement supprimer cette carte bancaire\xA0?',
    toastDeactivationSuccess: 'Cette carte virtuelle a été supprimée.',
    toastQueryError: 'Oups\xA0! Une erreur inconnue est survenue.',
  },
} as const);
